/*
 * Module for the performance tab on the Topic page
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/topicsSplit/topic/topicPerformance/topicPerformanceView",
  "modules/reportSplit/reports/singleReport/singleReportModule",
  "modules/topicsSplit/topic/topicPerformance/topicPerformanceModel",
  "moment",
], function (
  Marionette,
  Messenger,
  TopicPerformanceView,
  SingleReportModule,
  TopicPerformanceModel,
  Moment,
) {
  var TopicPerformanceController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "topicPerformance";
      this.region = options.region;
    },
    show: function (topic) {
      this.reports = Messenger.reqres.request("reports");
      var accuracyModel = new TopicPerformanceModel.accuracyModel({
        intentId: topic.get("intentId"),
      });
      accuracyModel.fetch();
      this.layout = new TopicPerformanceView.topicPerformanceLayout({ model: accuracyModel });
      //this.accuracyChart = this.addSubModule(new SingleReportModule({region: this.layout.accuracyChart}));
      this.trendingChart = this.addSubModule(
        new SingleReportModule({ region: this.layout.trendingChart }),
      );
      this.layout.on(
        "show",
        function () {
          this._showSubViews(topic);
        },
        this,
      );

      Messenger.reqres.setHandler(
        "report:layout",
        function () {
          return this.layout;
        },
        this,
      );

      this.showRegion(this.layout);
    },
    _showSubViews: function (topic) {
      Messenger.reqres.setHandler(
        "param:{touchpoint}",
        function () {
          var tps = Messenger.reqres.request("kb:touchpoints");
          var touchPointIdList = "";
          tps.each(function (tp) {
            touchPointIdList += tp.get("touchPointId") + "_";
          });
          return touchPointIdList;
        },
        this,
      );
      Messenger.reqres.setHandler(
        "param:{topic}",
        function () {
          return topic.get("intentId");
        },
        this,
      );
      Messenger.reqres.setHandler(
        "paramDisplay:{topic}",
        function () {
          return topic.get("intentName");
        },
        this,
      );
      Messenger.reqres.setHandler("param:{language}", function () {
        return Messenger.reqres.request("default:response:language");
      });
      Messenger.reqres.setHandler("param:{startDateDashMonth}", function () {
        return Moment().startOf("year").valueOf();
      });
      Messenger.reqres.setHandler("param:{endDateDashMonth}", function () {
        return Moment().valueOf();
      });
      Messenger.reqres.setHandler(
        "param:{timeZone}",
        function () {
          return Moment.tz.guess();
        },
        this,
      );
      this.reports.on(
        "sync",
        function () {
          //var accruacyReport = this.accuracyChart.findReport(this.reports, "Topic Accuracy");
          //this.accuracyChart.showReport(accruacyReport);
          var trendingReport = this.trendingChart.findReport(
            this.reports,
            "Trend Monthly Dashboard",
          );
          this.trendingChart.showIndividualReport(trendingReport);
        },
        this,
      );
    },
  });

  return TopicPerformanceController;
});
